import NoResultsEmptyState from '@components/v2/ui/EmptyState/NoResultsEmptyState';
import { Box } from '@mui/material';
import {
  VIRTUALIZED_TABLE_NO_RESULTS_TABLE_CELL_ID,
  VIRTUALIZED_TABLE_NO_RESULTS_TEST_ID,
} from '../virtualizedTableIds';

const VirtualizedTableNoResults = () => {
  return (
    <Box id={VIRTUALIZED_TABLE_NO_RESULTS_TABLE_CELL_ID}>
      <NoResultsEmptyState testId={VIRTUALIZED_TABLE_NO_RESULTS_TEST_ID} />
    </Box>
  );
};

export default VirtualizedTableNoResults;
